import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TemuShopProvider } from '@/temu-platform/context/TemuShopContext';
import TemuShopTopBar from '@/temu-platform/layout/TemuShopTopBar';
import TemuNoticeDrawerHost from '@/temu-platform/components/TemuNoticeDrawerHost';
import { TEMU_SHOP_SWITCH_TOAST_KEY } from '@/temu-platform/constants/temuRoutes';
import { showToast } from '@/utils/toast';
import '@/styles/temu-platform/temu-platform.css';
import '@/styles/temu-platform/temu-product-ops.css';

/**
 * 发布 / 编辑产品专用布局：保留顶栏店铺上下文，无左侧菜单。
 */
export default function TemuProductEditorLayout() {
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(TEMU_SHOP_SWITCH_TOAST_KEY);
      if (!raw) return;
      sessionStorage.removeItem(TEMU_SHOP_SWITCH_TOAST_KEY);
      const payload = JSON.parse(raw);
      if (payload?.message) {
        showToast(payload.message, payload.type || 'success');
      }
    } catch {
      sessionStorage.removeItem(TEMU_SHOP_SWITCH_TOAST_KEY);
    }
  }, []);

  return (
    <TemuShopProvider>
      <div
        className="temu-platform temu-platform--editor"
        data-testid="temu-product-editor-layout"
      >
        <TemuShopTopBar />
        <TemuNoticeDrawerHost />
        <div className="temu-platform__body temu-platform__body--editor">
          <main className="temu-platform__main temu-platform__main--product-ops temu-platform__main--editor">
            <Outlet />
          </main>
        </div>
      </div>
    </TemuShopProvider>
  );
}
